import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent {
    constructor( private dialogRef: MatDialogRef<DeleteDialogComponent>, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, isConfirm:boolean }) { }
         
         closeDialog(){
           this.dialog.closeAll();
         }
   
         onConfirm(): void {
           this.dialogRef.close(true); // Return true when confirmed
         }
       
         onCancel(): void {
           this.dialogRef.close(false); // Return false when canceled
         }
}
